/**
 * @generated SignedSource<<8849d8ca16167ab889424f8e33729267>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemCarousel_item$data = {
  readonly creators: ReadonlyArray<{
    readonly creator: {
      readonly name: string | null;
    } | null;
  } | null> | null;
  readonly isArt: boolean | null;
  readonly isAuctionEnabled: boolean | null;
  readonly pdpURL: string | null;
  readonly photos: ReadonlyArray<{
    readonly masterOrZoomPath: string | null;
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionPricePaddle_item" | "FavoritesItem_item">;
  readonly " $fragmentType": "PdpRespSimilarItemCarousel_item";
};
export type PdpRespSimilarItemCarousel_item$key = {
  readonly " $data"?: PdpRespSimilarItemCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemCarousel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "photos(limit:1)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuctionPricePaddle_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6d0dc4c6d9685a94bd60f0c916ba2816";

export default node;
